import React from "react";
import BreadCrumb from "common/breadcrumb";
import FaqSearch from "./faq-search";
import PopularAskQuestions from "./popular-ask-auestions";
import VideoTutorial from "./video-tutorial";

const Faqs = () => {
    return (
        <React.Fragment>
            <BreadCrumb title="FAQ's" pageTitle='Pages' />
            <FaqSearch />
            <PopularAskQuestions />
            <VideoTutorial />
        </React.Fragment>
    );
}

export default Faqs;